import { render, staticRenderFns } from "./MyStudentCom.vue?vue&type=template&id=7fde8e62&scoped=true"
import script from "./MyStudentCom.vue?vue&type=script&lang=js"
export * from "./MyStudentCom.vue?vue&type=script&lang=js"
import style0 from "./MyStudentCom.vue?vue&type=style&index=0&id=7fde8e62&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fde8e62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fde8e62')) {
      api.createRecord('7fde8e62', component.options)
    } else {
      api.reload('7fde8e62', component.options)
    }
    module.hot.accept("./MyStudentCom.vue?vue&type=template&id=7fde8e62&scoped=true", function () {
      api.rerender('7fde8e62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base-com/select/components/MyStudentCom.vue"
export default component.exports